import { useQuery } from "@tanstack/react-query";
import { refetchApiInterval } from "../../shared/constants";
import { getAssets } from "../api/assets-v1.service";
export const useGetAssetsV1Query = ({ enabled = true, paramsList }) => {
    return useQuery({
        enabled,
        gcTime: 0,
        queryFn: () => {
            return getAssets(paramsList);
        },
        queryKey: ["getAssetsV1", paramsList],
        refetchInterval: refetchApiInterval,
        retry: 0
    });
};
